import { serviceApi } from '~/features';

export async function downloadCurrentCnjpsList(campanhaId: string) {
  const response = await serviceApi.get<Blob>(
    `CampanhaProdutosPatrocinados/CnpjSegmented-Export/${campanhaId}`,
    {
      responseType: 'blob',
    }
  );
  return response;
}
